import { useMemo } from 'react';
import { useMarketData } from '../../hooks/useMarketData';
import type { Vendor } from '../../types';
import styles from './PrintView.module.css';

export function PrintView() {
  const { filteredVendors, categories, nameFor } = useMarketData();

  // Vendors at multiple booths fan out in `filteredVendors`; the printed list
  // shows one row per vendor identity.
  const uniqueVendors = useMemo(() => {
    const seen = new Set<string>();
    const out: Vendor[] = [];
    for (const v of filteredVendors) {
      if (seen.has(v.uid)) continue;
      seen.add(v.uid);
      out.push(v);
    }
    return out;
  }, [filteredVendors]);

  return (
    <div className={`${styles.printView} print-view`}>
      <div className={styles.legend}>
        <h2 className={styles.legendTitle}>Vendor Legend</h2>
        <div className={styles.legendGrid}>
          {categories.map(cat => (
            <div key={cat.id} className={styles.legendItem}>
              <span
                className={styles.legendSwatch}
                data-cat-id={cat.id}
              />
              <span className={styles.legendName}>{cat.name}</span>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.vendorList}>
        <h2 className={styles.vendorListTitle}>All Vendors</h2>
        {uniqueVendors.map((v, i) => {
          const cat = categories.find(c => c.id === v.categoryId);
          return (
            <div key={v.uid} className={styles.vendorItem}>
              <span className={styles.vendorNum}>{i + 1}</span>
              <span className={styles.vendorName}>{v.name}</span>
              <span
                className={styles.vendorCat}
                data-cat-id={v.categoryId}
              >
                {cat?.name ?? ''}
              </span>
              {nameFor(v.positionId) && <span className={styles.vendorLoc}>{nameFor(v.positionId)}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
